import { KrCard } from '@/common/card/KrCard';
import { Form } from '@/common/form/Form';
import { FormFields } from '@/common/form/rendering/FormFields';
import { useNavStateSync } from '@/common/hooks/navState/useNavStateSync';
import { ContentBox } from '@/common/layout/ContentBox';
import { Spacer, SpacerLayout } from '@/common/layout/SpacerLayout';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { Title } from '@/common/title/Title';
import { ForecastFeesChart } from '@/sc/entities/charts/ForecastFeesChart';
import { ForecastGrossSalesChart } from '@/sc/entities/charts/ForecastGrossSalesChart';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { Box, styled } from '@mui/material';
import { useEffect, useState } from 'react';

export const FeesForecastDashboard = () => {
  const { navState } = useNavState();

  const rsrc = useRsrc();
  // Filters
  const [fieldDefs, setFieldDefs] = useState();
  const [formValues, setFormValues] = useNavStateSync('formValues');

  useEffect(() => {
    rsrc.data('sc', 'FEES_DASHBOARD_FILTER_PLUGIN', {}).then((res) => {
      setFieldDefs([
        { field: 'startPeriodId', displayName: 'Start Period', type: 'DROPDOWN', values: res.periods },
        { field: 'endPeriodId', displayName: 'End Period', type: 'DROPDOWN', values: res.periods },
        { field: 'brandIds', displayName: 'Brands', type: 'TREE', treeData: res.brandTreeData },
      ]);

      if (!navState.formValues) {
        setFormValues({
          startPeriodId: res.periods[0].value,
          endPeriodId: res.periods[3].value,
          brandIds: res.brandIds,
        });
      }
    });
  }, []);

  if (!fieldDefs) {
    return;
  }

  return (
    <ContentBox>
      <Title icon={fas.faChartLine} title="DSA Forecasting" />

      {/* Filters */}
      <Form formValues={formValues} setFormValues={setFormValues}>
        <FormFields fieldDefs={fieldDefs} container={FilterContainer} />
      </Form>

      {/* Graphs */}
      <SpacerLayout>
        <Spacer vertical>
          <KrCard title="Quarter Over Quarter Gross Sales (by brand)" data-test-id={'bsales-chart'}>
            <ForecastGrossSalesChart formValues={formValues} />
          </KrCard>
          <KrCard title="Quarter Over Quarter Total Fees (by brand)" data-test-id={'bsales-chart'}>
            <ForecastFeesChart formValues={formValues} feeField={'total_fees'} />
          </KrCard>
          <Spacer>
            <KrCard title="Quarter Over Quarter Total FFS Fees (by brand)" data-test-id={'bsales-chart'}>
              <ForecastFeesChart formValues={formValues} feeField={'total_fees'} ffs={true} />
            </KrCard>
            <KrCard title="Quarter Over Quarter Total RDC FEES (by brand)" data-test-id={'bsales-chart'}>
              <ForecastFeesChart formValues={formValues} feeField={'total_fees'} ffs={false} />
            </KrCard>
          </Spacer>
        </Spacer>
      </SpacerLayout>
    </ContentBox>
  );
};

// TODO: Standardize Dashboards
const FilterContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  gap: theme.spacing(2),
}));
